
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexMx9ULuC1sW4wQmoyF17JX2PZiDuiY_iFFMPR_ZRYLRAMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/index.vue?macro=true";
import { default as accountJg8vYCRsMSt0lo5owT1GHJQ_459saGJGKia_JcFVYIX3cMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/account-settings/common-layer/pages/account.vue?macro=true";
import { default as indexm9Tux_45NB1WTh4q4Ox_w5KOGYaf2y2nNQBPXiw2YmGz4Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/index.vue?macro=true";
import { default as loginGevwEEy8DKeHGRndptjd20VKkDdG4B3jDcWgThsDlnIMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/login.vue?macro=true";
import { default as signupFnGVOk3DGl_zklDCw25Qlx0tfCUahHoQqdt6Bt2rse4Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/signup.vue?macro=true";
import { default as _91_46_46_46notFound_93cAdfS3Mcq94v5hTF_7JqkDM7v6urVkoPqychxhrJIuAMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/[...notFound].vue?macro=true";
import { default as indexe2pGQ_45Qhu4QYjF_0JJ18nyVRbCdTfWVyLKa_JUTXsjwMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/courses/index.vue?macro=true";
import { default as searchSYR_5ckQaitzZP5Sx1uAf8fhH_45bOp49wSPxqx8PoZu0Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/search.vue?macro=true";
import { default as indexsEk4wYm8Dugh_XBt8FnfFhjmF6PdqFczDwOyP09E6ScMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/invoices/index.vue?macro=true";
import { default as leadXrp5Jyepr8cEUak68Pvy2N64yKNnjPxuH66lchzXlGIMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/lead.vue?macro=true";
import { default as indexBhoQuotGoDhOX_45xrUDwtCkBHZ_45JRXcoi_45MiGHSnkWUoMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/contracts/index.vue?macro=true";
import { default as index2ycI0sdUtSmbZto2NZzkQ2A4UzvGQhPbfbpe6KFKRG8Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/dashboard/index.vue?macro=true";
import { default as indexM9a9QXSXFZiZmq3gI9AOiw71WaryOhS5x2Fwkxkr_OIMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/documents/index.vue?macro=true";
import { default as indexuoDA_45KaL3jf8ePiiZ1AseHuGIwr55TlmyRykkdYVyGEMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/estimates/index.vue?macro=true";
import { default as index2g6XRefD5XH2mC41vyMPv6GAwQuXSho_45cBm4OcSkzTwMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/index.vue?macro=true";
import { default as discoverHnxdRBF_457X8mDDvzYGNFcFBQRVCsQV6gWUk_453iZsuzcMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/courses/discover.vue?macro=true";
import { default as indexl5JpJeBHMntDC9GTbOt9LQbEya7KRXqYVr43jKB4fcMMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/communities/index.vue?macro=true";
import { default as index6Ay6RHJTC4T8wnX5dyng49mX_yo5jW9NGs8dx9vSB80Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/appointments/index.vue?macro=true";
import { default as my_45coursesHgN3wkkP5l2NFcoRm4TmEKGBpgJ_45iImwc0yBhsw6Cb8Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/courses/my-courses.vue?macro=true";
import { default as my_45libraryf3DDpCdlrDnUSyhSE_45eyUpG_457R_hdnTWAyyyvNretFgMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/my-library.vue?macro=true";
import { default as indexcn52RJpMZgUPdRRpq5Hivxnl2nGpxN_45_45iPJNQH8r7jYMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/shared-files/index.vue?macro=true";
import { default as campaignYhgcHBxqxqbnlhAJNFPdQHLFWp4Iys8B6FWrlIrCJjgMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/campaign.vue?macro=true";
import { default as reset_45passwordnJqQHDpKwwqaOgs11uN0qJ0Uj3sBb8VSuBtEk4uNRzoMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/reset-password.vue?macro=true";
import { default as _91productId_934sAw_452GwlUURAWPLXhCsLDPPhjGtRQjGsD6aoq7xYhYMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/[productId].vue?macro=true";
import { default as forgot_45passwordaRY8iSjq_45NLZTa2cexSUrrtokkQmXIqLtjnS44XOpooMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/forgot-password.vue?macro=true";
import { default as login_45with_45codeWWA115edJs3fIt5OYhQEqH_45YV8DLpDhN_404gZIXUf4Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/login-with-code.vue?macro=true";
import { default as discoverUzT_458WN_45GRGyAYNPEj3KecLBUeSwhUtcBNSwkJNH2_wMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/communities/discover.vue?macro=true";
import { default as commissionBW_45RZbiIU9wP8CJCSmyOk39YjHRLmvPFRqupi6X8bRwMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/commission.vue?macro=true";
import { default as expired_45passwordBKWmB9GI5n929JL0rkPLXQBLATmcvwxWTTSLVNrJ6kgMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/expired-password.vue?macro=true";
import { default as indexHcNe8aeINrNT3LTw1rnOm0OXikBjWV4xSqkMXk1UMCsMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/media/index.vue?macro=true";
import { default as sub_45affiliateVOnVRU5fQdPmjJXHQSslVnrDNN8VIrEH6sMw2lPjW_45EMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/sub-affiliate.vue?macro=true";
import { default as payout_45methodsjtiLOJHK_oDHJOk2GqaloD5Iojwv0iPdcLvkAzLUDEUMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/payout-methods.vue?macro=true";
import { default as profile_45confirmationwid_vt3NQ06YP4UscMKET6_KoHzlH3d0MFiJ_205cg4Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/profile-confirmation.vue?macro=true";
import { default as my_45communities9wetMUQkX_tcxYegp3lGVZEysyJ0fGs_h8RTLGyg6VoMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/communities/my-communities.vue?macro=true";
import { default as not_45found74MvHykR_rtkjuejkueusZCD8beCJobybSk_45vvT6JvcMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/not-found.vue?macro=true";
import { default as indexe1u8YrwCH35OwfSPL5RMxP05BJYzWvaDJ66d_452Kh7mYMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/conversations/index.vue?macro=true";
import { default as _91bundleOfferId_93D31Eh7WRpsVPWySu9xP01B7TedjX_VL9rJ594DwpMUoMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/courses/bundles/[bundleOfferId].vue?macro=true";
import { default as _91productId_937O6BLOxq49p4cIS7lz2EnGSOVOl58aSDZfHvh_j9N6kMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/products/new/[productId].vue?macro=true";
import { default as _91folderId_93LzCHYfjdLuORvbgH72gOtxNPTgiFQkpIfBnPCdl8gp0Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/media/folder/[folderId].vue?macro=true";
import { default as index_45WiaVTYOifxNbwzQi_glrwwNi5LOg1NAAfwlLw0_45iewMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/index.vue?macro=true";
import { default as indexY_45EIfnLgDIKND3PriyKZdCyV6sRRJKYbdaw9zmowMvIMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/products/[productId]/index.vue?macro=true";
import { default as _91postId_93nD0VuLhdXr3PFmlIwnzELQyZDNRXsb8NQsdWnY_Q3agMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/home/posts/[postId].vue?macro=true";
import { default as homeN87hA0ezkvhWR2htnvuEAtnutRBmith43S0N_gp_45bwUMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/home.vue?macro=true";
import { default as aboutNMGrWydU88TI7HI29iU8pFzeH1ubbFgnHGxr_tDaAbsMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/about.vue?macro=true";
import { default as indexqHDEa9Or3PukINLAS3BC6KZvf_cIFujYxyZ4CYqbCtUMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/index.vue?macro=true";
import { default as affiliatesIndexPage_46middlewareIsoiwkLKU5yIPl7RGZTAVbePff8iRsxJIRvt4gXSjlYMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/affiliatesIndexPage.middleware.ts?macro=true";
import { default as communitiesUEXg5KOHm_swmtw7g6YPSAPKTO7boJV_45NB8_e4AcRvMMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/communities.vue?macro=true";
import { default as _91conversationId_93dnaAknCHuL2zYHrGkt1NyygnhLl9PllFv7XX2KXi_TAMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/conversations/[conversationId].vue?macro=true";
import { default as leaderboardSfFt59VTK_452RbdvrQvBsZlT5lBk2oF_HNf5Cr_450O_dkMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/leaderboard.vue?macro=true";
import { default as contributionsTQp9cv6ILA5w0e9wBxdFrX51LVEQq0mnjJ6b8gch4ZcMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/contributions.vue?macro=true";
import { default as live_45sessionschoTsr9r1q6Ct57bQFrtfan1x8gW0__45QbDIAt_45Nm4LYMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/products/[productId]/live-sessions.vue?macro=true";
import { default as index2YM_AUG3whYFkCnBCvPZvVrC77VHaVBzEtY8sTVw8vcMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/events/index.vue?macro=true";
import { default as _91postId_937sD1P2VrEeR_45eiwqhsW4_45pztJDkHsdQKWZgjC0Z2Lb8Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/posts/[postId].vue?macro=true";
import { default as _91_46_46_46catchAll_93cBeLIPJirhq2j1JygnKQXjUusCr0N9P5ZnazEFK_45ei8Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/[...catchAll].vue?macro=true";
import { default as conversationsPKWqiSQBCKnAbYvEFtY5KbsCGHLZflOwqfARgVcfIxAMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/conversations.vue?macro=true";
import { default as indexVepnny3QlUXI4vAKLFz0Rvwpe3ChzMYuHmNAjrssqNoMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/members/index.vue?macro=true";
import { default as purchase_45coursecrjZSXsVGUGkrrADYyr6q4GOXllW10drMxGzeJ3c1zUMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/products/[productId]/purchase-course.vue?macro=true";
import { default as indexlylmEMeZ2_7Sk_45LDJP9q8wn_45Y_45onUXGK4sz5DP7pvgoMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/index.vue?macro=true";
import { default as indexoADs9VL468cxTnmUF2XWe0Zpye0VDUqb0cMP75K_45K2MMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/index.vue?macro=true";
import { default as detailsyNrPEaQJkzHVZVILTBBE43vTK0FVnZ8JIxxlEz7LvIUMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/details.vue?macro=true";
import { default as brandingYUU7TWa4dRcnzxVGiYW95mzOLbMkSZQvhmH3v_458742wMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/branding.vue?macro=true";
import { default as discoveryzpmxHx_452ONyafRQVq4OFNbE0KOM_45tpLlrgq_45zkFSuzQMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/discovery.vue?macro=true";
import { default as content_45unavailable5dNZbkD1NcqVa89xXEJDbJkEhmvDfeq3kvJ1gIguHr8Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/content-unavailable.vue?macro=true";
import { default as appearance5tI9AXPxsDeVCYqg2joVNaMrveDwKxTedq8Wnfz8ScgMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/appearance.vue?macro=true";
import { default as newsletterNgTRFBmMNsV0n3dec3Xj_IK1RVVKUeEWQN_XsvoDi6UMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/newsletter.vue?macro=true";
import { default as _91postId_93w8Dxg681Rb65kaB7ls1p4NxK8CMSMOAm8D_RrVWX9gsMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/channels/[channelSlug]/posts/[postId].vue?macro=true";
import { default as _91channelSlug_93fABMzv9fOag0e0yED_45_B3aKKoYZmj9lemsE1mKBr7AcMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/channels/[channelSlug].vue?macro=true";
import { default as subscriptionsjSCSNlm5T_olGF2KOlcZITyAlXtCIXz0sHcFlMFWDAEMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/subscriptions.vue?macro=true";
import { default as community_45tabswE_45GOwdIdSYoh03VC39Ci_HKQkfa39YWDuJwl25RhsIMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/community-tabs.vue?macro=true";
import { default as reported_45content8wxbaW4mtJ68ft05T1CT6bvi_45eHO_45GrsIPk6i9AD_45j8Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/reported-content.vue?macro=true";
import { default as promotional_45linksYIr5Z_45PPg5uMNdo3Aqy4aVwiAgLJgxFZ2F6dXMGOJWwMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/promotional-links.vue?macro=true";
import { default as gamification_45rewards4vPkXPOPrniEB1hXwoVV6GTHd3eAIJQEXQXl4mKyGXIMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/gamification-rewards.vue?macro=true";
import { default as membership_45questionsHbDTeIVOnoW2qe31OVZ5pqGNPK6wpYpIH420JLOmEC8Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/membership-questions.vue?macro=true";
import { default as _91lessonId_93A_0UK8FThh5_45JNjqByq_453cszLX_45YDYzXfaNUbzTH2RAMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/products/[productId]/modules/[moduleId]/lessons/[lessonId].vue?macro=true";
import { default as _91lessonId_93HOaeWVRwK6yz4CIy4Mfg13c7EgiDA4pB1bZs3yj9Hb4Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/products/[productId]/modules/[moduleId]/lessons/new/[lessonId].vue?macro=true";
import { default as purchaseR1SIZyfhoDmhZIoNd_aOTPxslXIiC_qW_7m42MZ36a8Meta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/courses/products/[productId]/purchase.vue?macro=true";
import { default as _91lessonId_932O5reW7J3mipiUgjU7rsloEz_45BLjTbi7c3KCLfCm16QMeta } from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/courses/products/[productId]/modules/[moduleId]/lessons/[lessonId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"cpRoute":true,"middleware":["redirect-clientportal-default-landing"]},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/index.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: { ...(accountJg8vYCRsMSt0lo5owT1GHJQ_459saGJGKia_JcFVYIX3cMeta || {}), ...{"middleware":[]} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/account-settings/common-layer/pages/account.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: { ...(indexm9Tux_45NB1WTh4q4Ox_w5KOGYaf2y2nNQBPXiw2YmGz4Meta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/index.vue")
  },
  {
    name: "auth-login",
    path: "/login",
    meta: { ...(loginGevwEEy8DKeHGRndptjd20VKkDdG4B3jDcWgThsDlnIMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/login.vue")
  },
  {
    name: "auth-signup",
    path: "/signup",
    meta: { ...(signupFnGVOk3DGl_zklDCw25Qlx0tfCUahHoQqdt6Bt2rse4Meta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/signup.vue")
  },
  {
    name: "notFound",
    path: "/:notFound(.*)*",
    meta: {"cpRoute":true,"middleware":["redirect-clientportal-default-landing"]},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/[...notFound].vue")
  },
  {
    name: "courses",
    path: "/courses",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/courses/index.vue")
  },
  {
    name: "courses-search",
    path: "/courses/search",
    meta: searchSYR_5ckQaitzZP5Sx1uAf8fhH_45bOp49wSPxqx8PoZu0Meta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/search.vue")
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/invoices/index.vue")
  },
  {
    name: "affiliates-lead",
    path: "/affiliates/lead",
    meta: { ...(leadXrp5Jyepr8cEUak68Pvy2N64yKNnjPxuH66lchzXlGIMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/lead.vue")
  },
  {
    name: "contracts",
    path: "/contracts",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/contracts/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/dashboard/index.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/documents/index.vue")
  },
  {
    name: "estimates",
    path: "/estimates",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/estimates/index.vue")
  },
  {
    name: "affiliates",
    path: "/affiliates",
    meta: { ...(index2g6XRefD5XH2mC41vyMPv6GAwQuXSho_45cBm4OcSkzTwMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/index.vue")
  },
  {
    name: "courses-discover",
    path: "/courses/discover",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/courses/discover.vue")
  },
  {
    name: "communities",
    path: "/communities",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/communities/index.vue")
  },
  {
    name: "appointments",
    path: "/appointments",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/appointments/index.vue")
  },
  {
    name: "courses-my-courses",
    path: "/courses/my-courses",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/courses/my-courses.vue")
  },
  {
    name: "courses-my-library",
    path: "/courses/my-library",
    meta: my_45libraryf3DDpCdlrDnUSyhSE_45eyUpG_457R_hdnTWAyyyvNretFgMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/my-library.vue")
  },
  {
    name: "shared-files",
    path: "/shared-files",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/shared-files/index.vue")
  },
  {
    name: "affiliates-campaign",
    path: "/affiliates/campaign",
    meta: { ...(campaignYhgcHBxqxqbnlhAJNFPdQHLFWp4Iys8B6FWrlIrCJjgMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/campaign.vue")
  },
  {
    name: "auth-reset-password",
    path: "/reset-password",
    meta: { ...(reset_45passwordnJqQHDpKwwqaOgs11uN0qJ0Uj3sBb8VSuBtEk4uNRzoMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/reset-password.vue")
  },
  {
    name: "courses-checkout",
    path: "/courses/:productId()",
    meta: _91productId_934sAw_452GwlUURAWPLXhCsLDPPhjGtRQjGsD6aoq7xYhYMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/[productId].vue")
  },
  {
    name: "auth-forgot-password",
    path: "/forgot-password",
    meta: { ...(forgot_45passwordaRY8iSjq_45NLZTa2cexSUrrtokkQmXIqLtjnS44XOpooMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-login-with-code",
    path: "/login-with-code",
    meta: { ...(login_45with_45codeWWA115edJs3fIt5OYhQEqH_45YV8DLpDhN_404gZIXUf4Meta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/login-with-code.vue")
  },
  {
    name: "communities-discover",
    path: "/communities/discover",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/communities/discover.vue")
  },
  {
    name: "affiliates-commission",
    path: "/affiliates/commission",
    meta: { ...(commissionBW_45RZbiIU9wP8CJCSmyOk39YjHRLmvPFRqupi6X8bRwMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/commission.vue")
  },
  {
    name: "auth-expired-password",
    path: "/expired-password",
    meta: { ...(expired_45passwordBKWmB9GI5n929JL0rkPLXQBLATmcvwxWTTSLVNrJ6kgMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/expired-password.vue")
  },
  {
    name: "affiliates-media",
    path: "/affiliates/media",
    meta: { ...(indexHcNe8aeINrNT3LTw1rnOm0OXikBjWV4xSqkMXk1UMCsMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/media/index.vue")
  },
  {
    name: "affiliates-sub-affiliate",
    path: "/affiliates/sub-affiliate",
    meta: { ...(sub_45affiliateVOnVRU5fQdPmjJXHQSslVnrDNN8VIrEH6sMw2lPjW_45EMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/sub-affiliate.vue")
  },
  {
    name: "affiliates-payout-methods",
    path: "/affiliates/payout-methods",
    meta: { ...(payout_45methodsjtiLOJHK_oDHJOk2GqaloD5Iojwv0iPdcLvkAzLUDEUMeta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/payout-methods.vue")
  },
  {
    name: "auth-profile-confirmation",
    path: "/profile-confirmation",
    meta: { ...(profile_45confirmationwid_vt3NQ06YP4UscMKET6_KoHzlH3d0MFiJ_205cg4Meta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/auth/profile-confirmation.vue")
  },
  {
    name: "communities-my-communities",
    path: "/communities/my-communities",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/communities/my-communities.vue")
  },
  {
    name: "communities-groups-not-found",
    path: "/communities/groups/not-found",
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/not-found.vue")
  },
  {
    name: "communities-conversations",
    path: "/communities/conversations",
    meta: indexe1u8YrwCH35OwfSPL5RMxP05BJYzWvaDJ66d_452Kh7mYMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/conversations/index.vue")
  },
  {
    name: "courses-bundles-bundleOfferId",
    path: "/courses/bundles/:bundleOfferId()",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/courses/bundles/[bundleOfferId].vue")
  },
  {
    name: "courses-products-new-productId",
    path: "/courses/products/new/:productId()",
    meta: _91productId_937O6BLOxq49p4cIS7lz2EnGSOVOl58aSDZfHvh_j9N6kMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/products/new/[productId].vue")
  },
  {
    name: "affiliates-media-folder-folderId",
    path: "/affiliates/media/folder/:folderId()",
    meta: { ...(_91folderId_93LzCHYfjdLuORvbgH72gOtxNPTgiFQkpIfBnPCdl8gp0Meta || {}), ...{"cpRoute":true} },
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/media/folder/[folderId].vue")
  },
  {
    name: "communities-users-userSlug",
    path: "/communities/users/:userSlug()",
    meta: index_45WiaVTYOifxNbwzQi_glrwwNi5LOg1NAAfwlLw0_45iewMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/index.vue")
  },
  {
    name: "courses-products-productId",
    path: "/courses/products/:productId()",
    meta: indexY_45EIfnLgDIKND3PriyKZdCyV6sRRJKYbdaw9zmowMvIMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/products/[productId]/index.vue")
  },
  {
    name: "communities-groups-groupSlug-home",
    path: "/communities/groups/:groupSlug()/home",
    meta: homeN87hA0ezkvhWR2htnvuEAtnutRBmith43S0N_gp_45bwUMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/home.vue"),
    children: [
  {
    name: "communities-groups-groupSlug-home-posts-postId",
    path: "posts/:postId()",
    meta: _91postId_93nD0VuLhdXr3PFmlIwnzELQyZDNRXsb8NQsdWnY_Q3agMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/home/posts/[postId].vue")
  }
]
  },
  {
    name: "communities-groups-groupSlug-about",
    path: "/communities/groups/:groupSlug()/about",
    meta: aboutNMGrWydU88TI7HI29iU8pFzeH1ubbFgnHGxr_tDaAbsMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/about.vue")
  },
  {
    name: "communities-groups-groupSlug",
    path: "/communities/groups/:groupSlug()",
    meta: indexqHDEa9Or3PukINLAS3BC6KZvf_cIFujYxyZ4CYqbCtUMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/index.vue")
  },
  {
    name: "affiliates-affiliatesIndexPage.middleware",
    path: "/affiliates/affiliatesIndexPage.middleware",
    meta: {"cpRoute":true},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/clientportal/routing-layer/pages/affiliates/affiliatesIndexPage.middleware.ts")
  },
  {
    name: "communities-users-userSlug-communities",
    path: "/communities/users/:userSlug()/communities",
    meta: communitiesUEXg5KOHm_swmtw7g6YPSAPKTO7boJV_45NB8_e4AcRvMMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/communities.vue")
  },
  {
    name: "communities-conversations-conversationId",
    path: "/communities/conversations/:conversationId()",
    meta: _91conversationId_93dnaAknCHuL2zYHrGkt1NyygnhLl9PllFv7XX2KXi_TAMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/conversations/[conversationId].vue")
  },
  {
    name: "communities-groups-groupSlug-leaderboard",
    path: "/communities/groups/:groupSlug()/leaderboard",
    meta: leaderboardSfFt59VTK_452RbdvrQvBsZlT5lBk2oF_HNf5Cr_450O_dkMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/leaderboard.vue")
  },
  {
    name: "communities-users-userSlug-contributions",
    path: "/communities/users/:userSlug()/contributions",
    meta: contributionsTQp9cv6ILA5w0e9wBxdFrX51LVEQq0mnjJ6b8gch4ZcMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/contributions.vue")
  },
  {
    name: "courses-products-productId-live-sessions",
    path: "/courses/products/:productId()/live-sessions",
    meta: live_45sessionschoTsr9r1q6Ct57bQFrtfan1x8gW0__45QbDIAt_45Nm4LYMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/products/[productId]/live-sessions.vue")
  },
  {
    name: "communities-groups-groupSlug-events",
    path: "/communities/groups/:groupSlug()/events",
    meta: index2YM_AUG3whYFkCnBCvPZvVrC77VHaVBzEtY8sTVw8vcMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/events/index.vue")
  },
  {
    name: "communities-users-userSlug-posts-postId",
    path: "/communities/users/:userSlug()/posts/:postId()",
    meta: _91postId_937sD1P2VrEeR_45eiwqhsW4_45pztJDkHsdQKWZgjC0Z2Lb8Meta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/users/[userSlug]/posts/[postId].vue")
  },
  {
    name: "communities-groups-groupSlug-catchAll",
    path: "/communities/groups/:groupSlug()/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_93cBeLIPJirhq2j1JygnKQXjUusCr0N9P5ZnazEFK_45ei8Meta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/[...catchAll].vue")
  },
  {
    name: "communities-groups-groupSlug-conversations",
    path: "/communities/groups/:groupSlug()/conversations",
    meta: conversationsPKWqiSQBCKnAbYvEFtY5KbsCGHLZflOwqfARgVcfIxAMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/conversations.vue")
  },
  {
    name: "communities-groups-groupSlug-members",
    path: "/communities/groups/:groupSlug()/members",
    meta: indexVepnny3QlUXI4vAKLFz0Rvwpe3ChzMYuHmNAjrssqNoMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/members/index.vue")
  },
  {
    name: "courses-products-productId-purchase-course",
    path: "/courses/products/:productId()/purchase-course",
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/products/[productId]/purchase-course.vue")
  },
  {
    name: "communities-groups-groupSlug-learning",
    path: "/communities/groups/:groupSlug()/learning",
    meta: indexlylmEMeZ2_7Sk_45LDJP9q8wn_45Y_45onUXGK4sz5DP7pvgoMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/index.vue")
  },
  {
    name: "communities-groups-groupSlug-settings",
    path: "/communities/groups/:groupSlug()/settings",
    meta: indexoADs9VL468cxTnmUF2XWe0Zpye0VDUqb0cMP75K_45K2MMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/index.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-details",
    path: "/communities/groups/:groupSlug()/settings/details",
    meta: detailsyNrPEaQJkzHVZVILTBBE43vTK0FVnZ8JIxxlEz7LvIUMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/details.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-branding",
    path: "/communities/groups/:groupSlug()/settings/branding",
    meta: brandingYUU7TWa4dRcnzxVGiYW95mzOLbMkSZQvhmH3v_458742wMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/branding.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-discovery",
    path: "/communities/groups/:groupSlug()/settings/discovery",
    meta: discoveryzpmxHx_452ONyafRQVq4OFNbE0KOM_45tpLlrgq_45zkFSuzQMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/discovery.vue")
  },
  {
    name: "communities-groups-groupSlug-content-unavailable",
    path: "/communities/groups/:groupSlug()/content-unavailable",
    meta: content_45unavailable5dNZbkD1NcqVa89xXEJDbJkEhmvDfeq3kvJ1gIguHr8Meta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/content-unavailable.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-appearance",
    path: "/communities/groups/:groupSlug()/settings/appearance",
    meta: appearance5tI9AXPxsDeVCYqg2joVNaMrveDwKxTedq8Wnfz8ScgMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/appearance.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-newsletter",
    path: "/communities/groups/:groupSlug()/settings/newsletter",
    meta: newsletterNgTRFBmMNsV0n3dec3Xj_IK1RVVKUeEWQN_XsvoDi6UMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/newsletter.vue")
  },
  {
    name: "communities-groups-groupSlug-channels-channelSlug",
    path: "/communities/groups/:groupSlug()/channels/:channelSlug()",
    meta: _91channelSlug_93fABMzv9fOag0e0yED_45_B3aKKoYZmj9lemsE1mKBr7AcMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/channels/[channelSlug].vue"),
    children: [
  {
    name: "communities-groups-groupSlug-channels-channelSlug-posts-postId",
    path: "posts/:postId()",
    meta: _91postId_93w8Dxg681Rb65kaB7ls1p4NxK8CMSMOAm8D_RrVWX9gsMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/channels/[channelSlug]/posts/[postId].vue")
  }
]
  },
  {
    name: "communities-groups-groupSlug-settings-subscriptions",
    path: "/communities/groups/:groupSlug()/settings/subscriptions",
    meta: subscriptionsjSCSNlm5T_olGF2KOlcZITyAlXtCIXz0sHcFlMFWDAEMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/subscriptions.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-community-tabs",
    path: "/communities/groups/:groupSlug()/settings/community-tabs",
    meta: community_45tabswE_45GOwdIdSYoh03VC39Ci_HKQkfa39YWDuJwl25RhsIMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/community-tabs.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-reported-content",
    path: "/communities/groups/:groupSlug()/settings/reported-content",
    meta: reported_45content8wxbaW4mtJ68ft05T1CT6bvi_45eHO_45GrsIPk6i9AD_45j8Meta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/reported-content.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-promotional-links",
    path: "/communities/groups/:groupSlug()/settings/promotional-links",
    meta: promotional_45linksYIr5Z_45PPg5uMNdo3Aqy4aVwiAgLJgxFZ2F6dXMGOJWwMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/promotional-links.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-gamification-rewards",
    path: "/communities/groups/:groupSlug()/settings/gamification-rewards",
    meta: gamification_45rewards4vPkXPOPrniEB1hXwoVV6GTHd3eAIJQEXQXl4mKyGXIMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/gamification-rewards.vue")
  },
  {
    name: "communities-groups-groupSlug-settings-membership-questions",
    path: "/communities/groups/:groupSlug()/settings/membership-questions",
    meta: membership_45questionsHbDTeIVOnoW2qe31OVZ5pqGNPK6wpYpIH420JLOmEC8Meta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/settings/membership-questions.vue")
  },
  {
    name: "courses-products-productId-modules-moduleId-lessons-lessonId",
    path: "/courses/products/:productId()/modules/:moduleId()/lessons/:lessonId()",
    meta: _91lessonId_93A_0UK8FThh5_45JNjqByq_453cszLX_45YDYzXfaNUbzTH2RAMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/products/[productId]/modules/[moduleId]/lessons/[lessonId].vue")
  },
  {
    name: "courses-products-productId-modules-moduleId-lessons-new-lessonId",
    path: "/courses/products/:productId()/modules/:moduleId()/lessons/new/:lessonId()",
    meta: _91lessonId_93HOaeWVRwK6yz4CIy4Mfg13c7EgiDA4pB1bZs3yj9Hb4Meta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/courses/routing-layer/pages/courses/products/[productId]/modules/[moduleId]/lessons/new/[lessonId].vue")
  },
  {
    name: "courses-purchase-product",
    path: "/communities/groups/:groupSlug()/learning/courses/products/:productId()/purchase",
    meta: purchaseR1SIZyfhoDmhZIoNd_aOTPxslXIiC_qW_7m42MZ36a8Meta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/courses/products/[productId]/purchase.vue")
  },
  {
    name: "communities-groups-groupSlug-learning-courses-products-productId-modules-moduleId-lessons-lessonId",
    path: "/communities/groups/:groupSlug()/learning/courses/products/:productId()/modules/:moduleId()/lessons/:lessonId()",
    meta: _91lessonId_932O5reW7J3mipiUgjU7rsloEz_45BLjTbi7c3KCLfCm16QMeta || {},
    component: () => import("/tmp/workspace/staging/ghl-membership-frontend-clientportal/libs/layers/communities/routing-layer/pages/communities/groups/[groupSlug]/learning/courses/products/[productId]/modules/[moduleId]/lessons/[lessonId].vue")
  }
]